import { render, staticRenderFns } from "./uservoice.vue?vue&type=template&id=e07c7a64&scoped=true&"
import script from "./uservoice.vue?vue&type=script&lang=js&"
export * from "./uservoice.vue?vue&type=script&lang=js&"
import style0 from "./uservoice.vue?vue&type=style&index=0&id=e07c7a64&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07c7a64",
  null
  
)

export default component.exports